module.exports = __webpack_public_path__ + "static/img/45.9f17bfd3.jpg";